import fetchClient from './configuration';
import { getUrl, routeAPI } from './constants';

class ConsignorGroupAPI {
  static async getConsignorGroups() {
    const url = getUrl(routeAPI.CONSIGNOR_GROUPS);
    const res = await fetchClient.get(url);
    return res.data;
  }
}
export default ConsignorGroupAPI;
